import {Button} from "primereact/button";
import React from "react";
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import DHTextFieldSmall from "../../general/DHTextFieldSmall";


export default function EventVeranstalterAusrichterDatenComp({eventOperatorId, isEventAbgeschlossen, isAustragungsortPflicht = false, austragungsortTelefon,
                                                                 austragungsortEmail,
                                                                 socialmedia, homepage,
                                                                 austragungsortBezeichnung,
                                                                 austragungsortStrasse,
                                                                 austragungsortPLZ,
                                                                 austragungsortOrt,
                                                                 onError,
                                                                 onChangeHomepage,
                                                                 onChangeSocialmedia,
                                                                 onChangeAustragungsortBezeichnung,
                                                                 onChangeAustragungsortStrasse,
                                                                 onChangeAustragungsortPLZ,
                                                                 onChangeAustragungsortOrt,
                                                                 onChangeAustragungsortEmail,
                                                                 onChangeAustragungsortTelefon}) {

    const eventOperatorDatenVorbelegen = () => {
        onError(undefined);

        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.eventoperator + "/byId/" + eventOperatorId,
            json => {
                onChangeHomepage(json.homepage);
                onChangeSocialmedia(json.socialmedia);
                onChangeAustragungsortBezeichnung(json.austragungsortBezeichnung);
                onChangeAustragungsortStrasse(json.austragungsortStrasse);
                onChangeAustragungsortPLZ(json.austragungsortPLZ);
                onChangeAustragungsortOrt(json.austragungsortOrt);
                onChangeAustragungsortEmail(json.email);
                onChangeAustragungsortTelefon(json.telefon);
            },
            responseNotOk => {
                onError("Fehler beim Laden der Veranstalterdaten: " + responseNotOk.message);
            },
            error => {
                onError("Fehler beim Laden der Veranstalterdaten: " + error.message);
            }
        );
    }

    return <>
        <Button label="Veranstalter- und Ausrichtungsortdaten aus Standard vorbelegen?" onClick={() => eventOperatorDatenVorbelegen()}/>
        <h3>Veranstalterdaten</h3>
        <div style={{marginBottom: 10}}>
            <DHTextFieldSmall showPlaceholder={false} label="Telefon" value={austragungsortTelefon} onChange={(text) => onChangeAustragungsortTelefon(text)} disabled={isEventAbgeschlossen}
                              width={300}/>
        </div>
        <div style={{marginBottom: 10}}>
            <DHTextFieldSmall showPlaceholder={false} label="Email" value={austragungsortEmail} onChange={(text) => onChangeAustragungsortEmail(text)} disabled={isEventAbgeschlossen}
                              width={300}/>
        </div>
        <div style={{marginBottom: 10}}>
            <DHTextFieldSmall showPlaceholder={false} label="Socialmedia-Link" value={socialmedia} onChange={(text) => onChangeSocialmedia(text)} disabled={isEventAbgeschlossen}
                              width={300}/>
        </div>
        <div style={{marginBottom: 10}}>
            <DHTextFieldSmall showPlaceholder={false} label="Homepage-Link" value={homepage} onChange={(text) => onChangeHomepage(text)} disabled={isEventAbgeschlossen}
                              width={300}/>
        </div>
        <h3>Daten zum Austragungsort</h3>
        <div style={{marginBottom: 10}}>
            <DHTextFieldSmall showPlaceholder={false} label="Bezeichnung" value={austragungsortBezeichnung} onChange={(text) => onChangeAustragungsortBezeichnung(text)} disabled={isEventAbgeschlossen}
                              width={300}/>
            <div>(z.B Sportheim Hummelshausen)</div>
        </div>
        <div style={{marginBottom: 10}}>
            <DHTextFieldSmall showPlaceholder={false} label="Strasse" value={austragungsortStrasse} onChange={(text) => onChangeAustragungsortStrasse(text)} disabled={isEventAbgeschlossen}
                              width={300}/>
        </div>
        <div style={{marginBottom: 10}}>
            <DHTextFieldSmall showPlaceholder={false} label="PLZ" required={isAustragungsortPflicht} value={austragungsortPLZ} onChange={(text) => onChangeAustragungsortPLZ(text)} disabled={isEventAbgeschlossen}
                              width={300}/>
        </div>
        <div style={{marginBottom: 10}}>
            <DHTextFieldSmall showPlaceholder={false} label="Ort" required={isAustragungsortPflicht} value={austragungsortOrt} onChange={(text) => onChangeAustragungsortOrt(text)} disabled={isEventAbgeschlossen}
                              width={300}/>
        </div>
    </>
}